export default "<p>push-notification-container works!</p>\n";